// extracted by mini-css-extract-plugin
export default {"createPollContainer":"CreatePoll_createPollContainer__XszW5","createPollForm":"CreatePoll_createPollForm__J63xz","verticalLine":"CreatePoll_verticalLine__BpVDh"};